"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UserProfile = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _now = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/date/now"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _react = _interopRequireWildcard(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _AuButton = _interopRequireWildcard(require("../elements/AuButton"));
var _AutoIntl = _interopRequireDefault(require("../elements/AutoIntl"));
var _List = _interopRequireDefault(require("../elements/List"));
var _CountdownTimer = _interopRequireDefault(require("../elements/CountdownTimer"));
var _auth = require("../../utils/auth");
var _copyTextToClipboard = _interopRequireDefault(require("../../utils/copyTextToClipboard"));
var _context3;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "container": "user_profile-module__container___yFHba",
  "section": "user_profile-module__section___OS2HK",
  "title": "user_profile-module__title___MhAcb",
  "button": "user_profile-module__button___W1duh",
  "list": "user_profile-module__list___IxX2s",
  "username_copied": "user_profile-module__username_copied___YW6w5",
  "copied": "user_profile-module__copied___pEom8",
  "logout": "user_profile-module__logout___eKw95",
  "divider": "user_profile-module__divider___HCB21",
  "namecontainer": "user_profile-module__namecontainer___iQlvh",
  "username": "user_profile-module__username___zJuOQ",
  "id": "user_profile-module__id___MFVsZ",
  "token_container": "user_profile-module__token_container___zI1ir",
  "listvalue": "user_profile-module__listvalue___BdgCB",
  "inputcontainer": "user_profile-module__inputcontainer___ktIYM",
  "list_value_inner": "user_profile-module__list_value_inner___DWYXj",
  "tokenvalue": "user_profile-module__tokenvalue___TDf3b",
  "username_input__container": "user_profile-module__username_input__container___nlIrW",
  "title_container": "user_profile-module__title_container___klyOm",
  "title_user": "user_profile-module__title_user___opR7A user_profile-module__title___MhAcb",
  "title_token": "user_profile-module__title_token___RPfzP user_profile-module__title___MhAcb"
};
class UserProfile extends _react.PureComponent {
  static propTypes = {
    name: T.string.isRequired,
    email: T.string.isRequired,
    accessToken: T.string.isRequired,
    accessTokenExp: T.number.isRequired,
    refreshToken: T.string,
    refreshTokenExp: T.number,
    logOutFn: T.func,
    username: T.string.isRequired,
    onUserTokenClick: T.func,
    onUserClientClick: T.func
  };
  constructor(props) {
    super(props);
    this.state = {};
  }
  addClassesListItem(listItem) {
    if (listItem) {
      listItem.className = styles.listrow;
      listItem.valueClassName = styles.list_value_inner;
    }
    return listItem;
  }
  createProfileListItem(labelId, valueString) {
    let valueComponent;
    if (this.state[labelId] === valueString) {
      // username has been copied
      valueComponent = /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
        displayId: "au.userProfile.copiedToClipboard",
        className: styles.username_copied,
        tag: "div"
      });
    } else {
      const onClick = () => {
        (0, _copyTextToClipboard.default)(valueString);
        this.setState({
          [labelId]: valueString
        });
        (0, _setTimeout2.default)(() => this.setState({
          [labelId]: undefined
        }), 5000);
      };
      valueComponent = /*#__PURE__*/_react.default.createElement(_AuButton.default, {
        type: _AuButton.BUTTON_TYPE_PLAIN,
        displayId: "au.userProfile.copyToken",
        onClick: onClick,
        className: styles.button
      });
    }
    const el = /*#__PURE__*/_react.default.createElement("div", {
      className: styles.listvalue
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.username_input__container
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.username
    }, valueString), valueComponent));
    return {
      labelId,
      valueComponent: el
    };
  }
  createNameListItem(labelId, valueString) {
    if (valueString === '' || valueString === undefined) return false;
    const el = /*#__PURE__*/_react.default.createElement("div", {
      className: styles.listvalue
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.namecontainer
    }, valueString));
    return {
      labelId,
      valueComponent: el
    };
  }
  renderProfile() {
    var _context;
    const {
      name,
      email,
      username,
      onUserClientClick
    } = this.props;
    const list = (0, _map.default)(_context = [this.createProfileListItem('au.userProfile.userName', username), this.createNameListItem('au.userProfile.fullName', name), this.createNameListItem('au.userProfile.emailAddress', email)]).call(_context, this.addClassesListItem);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: styles.section
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.title_container
    }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      displayId: "au.userProfile.user",
      className: styles.title_user
    }), onUserClientClick && /*#__PURE__*/_react.default.createElement(_AuButton.default, {
      type: _AuButton.BUTTON_TYPE_PLAIN,
      displayId: "au.customCredentials.tab.client",
      onClick: onUserClientClick,
      className: styles.button
    })), /*#__PURE__*/_react.default.createElement(_List.default, {
      list: list,
      className: styles.userinfo
    }));
  }
  createTokenListItem(labelId, tokenValue, tokenExpTime) {
    if (!tokenValue) {
      // specifically for not having a refresh token
      return false;
    }
    let valueComponent;
    if (this.state[labelId] === tokenValue) {
      // this token has been copied
      valueComponent = /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
        displayId: "au.userProfile.copiedToClipboard",
        className: styles.copied,
        tag: "div"
      });
    } else {
      // fresh token
      const onClick = () => {
        (0, _copyTextToClipboard.default)(tokenValue);
        this.setState({
          [labelId]: tokenValue
        });
        (0, _setTimeout2.default)(() => this.setState({
          [labelId]: undefined
        }), 5000); // show copied message for five seconds
      };

      valueComponent = /*#__PURE__*/_react.default.createElement(_AuButton.default, {
        type: _AuButton.BUTTON_TYPE_PLAIN,
        displayId: "au.userProfile.copyToken",
        onClick: onClick,
        className: styles.button
      });
    }
    let countdownComponent = /*#__PURE__*/_react.default.createElement(_CountdownTimer.default, {
      eventTime: tokenExpTime
    });
    const el = /*#__PURE__*/_react.default.createElement("div", {
      className: styles.tokenvalue
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.token_container
    }, countdownComponent, valueComponent));
    return {
      labelId,
      valueComponent: el
    };
  }
  renderTokens() {
    var _context2;
    const {
      accessToken,
      refreshToken,
      accessTokenExp,
      refreshTokenExp,
      onUserTokenClick
    } = this.props;
    const list = (0, _map.default)(_context2 = [this.createTokenListItem('au.userProfile.accessToken', accessToken, accessTokenExp), this.createTokenListItem('au.userProfile.refreshToken', refreshToken, refreshTokenExp)]).call(_context2, this.addClassesListItem);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: styles.section
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.title_container
    }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      displayId: "au.userProfile.token",
      className: styles.title_token
    }), onUserTokenClick && /*#__PURE__*/_react.default.createElement(_AuButton.default, {
      type: _AuButton.BUTTON_TYPE_PLAIN,
      displayId: "au.customCredentials.tab.token",
      onClick: onUserTokenClick,
      className: styles.button
    })), /*#__PURE__*/_react.default.createElement(_List.default, {
      list: list,
      className: styles.list
    }));
  }
  renderLogOut() {
    const {
      logOutFn
    } = this.props;
    if (!logOutFn) return false;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: styles.logout
    }, /*#__PURE__*/_react.default.createElement(_AuButton.default, {
      "data-tcl": "UserProfile-logOut",
      displayId: "au.userProfile.logOut",
      onClick: logOutFn,
      className: styles.button,
      type: "secondary"
    }));
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: styles.container
    }, this.renderProfile(), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.divider
    }), this.renderTokens(), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.divider
    }), this.renderLogOut());
  }
}
exports.UserProfile = UserProfile;
const noAuth = process.env.REACT_APP_NO_AUTH === 'true';
class ConnectedUserProfile extends _react.PureComponent {
  constructor(props) {
    super(props);
    if (noAuth) {
      this.state = {
        name: 'N/A',
        email: 'N/A',
        username: 'N/A',
        accessToken: Math.random().toString(36).substring(7),
        accessTokenExp: (0, _now.default)(),
        refreshToken: Math.random().toString(36).substring(7),
        refreshTokenExp: (0, _now.default)()
      };
    } else {
      // assuming name and email will not change
      this.state = {
        name: _auth.clientContainer.client.fullName,
        email: _auth.clientContainer.client.email,
        username: _auth.clientContainer.client.userName,
        accessToken: _auth.clientContainer.client.accessToken,
        accessTokenExp: _auth.clientContainer.client.accessTokenExp,
        refreshToken: _auth.clientContainer.client.refreshToken,
        refreshTokenExp: _auth.clientContainer.client.refreshTokenExp
      };
    }
  }
  updateTokens = (0, _bind.default)(_context3 = this.updateTokens).call(_context3, this);
  updateTokens(tokens) {
    const {
      accessToken,
      accessTokenExp,
      refreshToken,
      refreshTokenExp
    } = tokens;
    this.setState({
      accessToken,
      accessTokenExp,
      refreshToken,
      refreshTokenExp
    });
  }
  componentDidMount() {
    if (!noAuth) _auth.clientContainer.client.registerAuthRefresh(this.updateTokens);
  }
  componentWillUnmount() {
    if (!noAuth) _auth.clientContainer.client.unregisterAuthRefresh(this.updateTokens);
  }
  render() {
    const {
      onUserTokenClick,
      onUserClientClick
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(UserProfile, (0, _extends2.default)({}, this.state, {
      onUserTokenClick: onUserTokenClick,
      onUserClientClick: onUserClientClick
    }));
  }
}
exports.default = ConnectedUserProfile;